export default "__VITE_ASSET__DjijOuvO__"